import {
  PAY_MODE,
} from '@/config/rentConfig'

export const onSetFee = (feeList) => {
  return (arr, fee) => {
    if (fee.payMode === PAY_MODE.POSTPAID_ITEM) {
      arr.push({
        ...fee,
        totalAmount: fee.planAmount,
        payModeText: '后置费项收款',
        isConfirm: true,
        name: fee.name || fee.fundTypeName,
        amount: fee.planAmount,
      })
    } else {
      const findFee = feeList.find((i) => i.code === fee.fundType)
      if (findFee) {
        const item = getFeeItem(fee, findFee)
        arr.push(item)
      }
    }
    return arr
  }
}
export const getFeeItem = (data, extData) => {
  return {
    ...data,
    isConfirm: !!data.payMode,
    toast: extData.toast, // 提示语
    required: extData.required, // 是否必填费项
    fundType: data.type || data.fundType, // 费项code（押金，租金......）
    name: data.name || data.typeName || data.fundTypeName, // 费项名称
    payMode: data.payMode || data.payMethod, // 收款方式
    isSelectScheme: true, // 是否是选的租赁方案
    amount: data.amount || data.planAmount, // 金额
    spId: data.spId, // 完单平台
    dynamicType: data.dynamicType, // 动态条件
    dynamicList: data.dynamicList, // 动态租金配置
    payPlanType: data.payPlanType === undefined ? null : data.payPlanType, // 租金类型
  }
}
